import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'
import { readProjectEnvVar } from '@cli-utils/files.js'

export function hasRequiredIntegrationEnv(
  definition: BetterstartIntegrationDefinition,
  cwd: string
): boolean {
  const requiredKeys = definition.envSections.flatMap((section) =>
    section.vars.filter((entry) => entry.value === '').map((entry) => entry.key)
  )
  return requiredKeys.every((key) => Boolean(readProjectEnvVar(cwd, key)))
}
